const modalPopup = () => {
	const modalLinks = document.querySelectorAll('.modal-link');

	// If empty, return early.
	if (!modalLinks.length) {
		return;
	}

	window.addEventListener(
		'click',
		(event) => {
			if (
				event.target.matches('.modal-link')
			) {
				const modalWindow = document.querySelector(`[data-modal="${event.target.id}"]`);
				openModal(modalWindow);
			} else if (
				event.target.matches('.modal-link a')
			) {
				const modalWindow = document.querySelector(`[data-modal="${event.target.parentNode.id}"]`);
				openModal(modalWindow);
			} else if (
				event.target.matches('.modal-window.is-open') || event.target.matches('.modal-close')
			) {
				closeModal(event.target);
			}
		},
		false
	);

	const openModal = (modalWindow) => {
		document.body.classList.add('has-open-modal');
		modalWindow.classList.add('is-open');
	};

	const closeModal = () => {
		const modalWindow = document.querySelector('.modal-window.is-open');

		document.body.classList.remove('has-open-modal');
		modalWindow.classList.remove('is-open');
	};
};

export default modalPopup;